export const FETCH_DEBOUNCE_DELAY = 250
export const AUTH_CREDENTIALS_ERROR_MSG = 'Authentication credentials were not provided.'
export const SESSION_EXPIRED = 'Your session has expired. Please log in again.'
export const UNEXPECTED_AUTOCOMPLETE_ERROR = 'There was an unexpected error with the autocomplete. Please try again.'
export const UNEXPECTED_ERROR_NOTIFIED =
  'An unexpected error occurred. We are working to resolve the issue, please try again later. If this problem persists, please contact support.'
